import { render } from "./AssetType1.vue?vue&type=template&id=76429554"
import script from "./AssetType1.vue?vue&type=script&lang=js"
export * from "./AssetType1.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ranjanbajracharya/Documents/upwork/kaz/mbsm-pwa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__